import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import UserFamilyList from './UserFamilyList';

loadDOMComponent({
	selector: 'react-user-family-list',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<UserFamilyList userId={userId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
